export enum VETTING_SOURCE {
	'MY_CARRIER_PACKETS' = 'MY_CARRIER_PACKETS',
	'RMIS' = 'RMIS',
	'C4' = 'C4',
}
